import React from 'react';
import utils from "../../modules/utils";
import { connect } from 'react-redux';
import { setDatiPersonali } from "../../actions/index";

const mapDispatchToProps = dispatch => {
    return {
        setDatiPersonali: (d) => dispatch(setDatiPersonali(d))
    }
}
class ModalError extends React.Component {
    handleClose = () => {
        const modal = document.querySelector('.modal-error-container');
        modal.classList.remove('is-modal-shown');
        //Rimosso il 11-11-2020 per evitare errori in modifica
        /*if (modal.dataset.errorCode === '1') {
            this.props.setDatiPersonali({
                'cancella_dati_locali': true
            });
            utils.getCurrentStep();
        }*/
    }
    
    render() {
        return (
            <div className="modal-error-container">
                <div className="modal-error-relative">
                    <div className="modal-error">
                        <img className="error-img" src="./img/modal-error.png" alt="Errore" />
                        <p className="error-text">Qualcosa è andato storto</p>
                        <button className="bottone" onClick={() => this.handleClose()}>Chiudi</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(ModalError);


// WEBPACK FOOTER //
// ./src/components/shared/modal_errore.js